import { CapoPlugin } from "/home/denis/sources/sos-amiante/client/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];